(function () {
  function initBundleSelector(form) {
    var options = form.querySelectorAll('[data-bs-option]');
    var radios = form.querySelectorAll('.bs-option__radio');
    var submitBtn = form.querySelector('[data-bs-submit]');
    var submitText = form.querySelector('[data-bs-submit-text]');
    var errorEl = form.querySelector('[data-bs-error]');

    function updateSelectedStyles() {
      options.forEach(function (opt) {
        var radio = opt.querySelector('.bs-option__radio');
        opt.classList.toggle('is-selected', radio.checked);
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', updateSelectedStyles);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var selected = form.querySelector('.bs-option__radio:checked');
      if (!selected) return;

      var variantId = selected.value;

      submitBtn.disabled = true;
      var originalText = submitText.textContent;
      submitText.textContent = 'Agregando...';
      errorEl.hidden = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add to cart failed');
          return response.json();
        })
        .then(function () {
          submitText.textContent = '¡Agregado! ✓';
          // Refresca la página del carrito/drawer si el tema lo soporta
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            // Redirige al carrito para que el cliente vea lo que agregó
            window.location.href = '/cart';
          }, 600);
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitText.textContent = originalText;
          errorEl.hidden = false;
        });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bs-form]').forEach(initBundleSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var forms = e.target.querySelectorAll('[data-bs-form]');
    forms.forEach(initBundleSelector);
  });
})();